import { RefundStatusLookup } from './RefundStatusLookup';
import { Header } from './Header';

export class RefundStatusRq {
    header?: Header;
    refundLookupStatus: Array<RefundStatusLookup>;
}
